import React from 'react';
import 'animate.css';
import ConvertLogo from "../../assets/img/convert-logo.png" 
import UtilService from '../../services/util';
import { FaLockOpen, FaDiscord } from "react-icons/fa";
import { CgMail } from "react-icons/cg";
import useAuth from '../../context/AuthContext';

const BoasVindas = () => {
  UtilService.setTitle("Boas-vindas");
  const { user } = useAuth();

  const resource_access = user?.roles['convert-api'] ? user?.roles['convert-api']['roles'] : [];

  const styles = {
        "pageContainer" : {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '90vh',
            overflowY: 'hidden',
        },
        "p":{
            width:'70%', 
            fontSize: '22px', 
            textAlign: 'center'
        },
        "firstAccess": {
          marginTop: '16px',
          width: '50%',
          height: 'auto',
          background: 'rgba(255, 255, 255, 0.44)',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
          backdropFilter: 'blur(5.3px)',
          WebkitBackdropFilter: 'blur(5.3px)',
          border: '1px solid rgba(255, 255, 255, 0.21)',
          borderRadius: '20px',
          padding: '20px 40px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'flex-start',
          flexDirection: 'column'
        },
        "h2": {
            fontSize: '22px',
            marginTop: '20px',
            marginBottom: '24px',
            width: '100%',
        },
        "h3": {
            fontSize: '18px',
            marginBottom: '16px',
        },
        "h4": {
            fontSize: '16px',
            marginBottom: '10px',
        },
        "ulList": {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '8px',
            listStyle: 'none',
            padding: '8px 16px',
        },
        "liItem": {
            fontSize: '14px',
        },
        "a": {
            color: "#686cdaff",
            textDecoration: 'none',
        }
    }

  return (
    <div style={styles.pageContainer}>
      <img src={ConvertLogo} style={{width: '400px'}} class="animate__animated animate__bounceInDown" alt="Logo do convert"/>
      <h1 className="animate__animated animate__bounceInUp">Bem-vindo! 🤗</h1>
      <p style={styles.p} className="animate__animated animate__bounceInUp">O Convert é um sistema interno desenvolvido para facilitar a gestão financeira, o controle dos gestores e o planejamento estratégico de projetos da Vertigo Tecnologia.
        Ele ajuda a alcançar melhores resultados, otimizando processos e promovendo uma visão clara e integrada de todas as operações.</p>
      {
        resource_access.length == 0 &&
        <div className="animate__animated animate__bounceInUp" style={styles.firstAccess}>
          <h2 style={styles.h2}>Olá! Parece que esse é seu primeiro acesso. </h2> 
          <h3 style={styles.h3}>Por favor, entre em contato com o seu gestor para que o acesso ao Convert seja liberado <FaLockOpen style={{marginBottom: '5px'}}/> </h3>
          <h4 style={styles.h4}>Confira abaixo algumas pessoas que podem te ajudar:</h4>
          <ul style={styles.ulList}>
              <li style={styles.liItem}><b>Claudia Mere:</b> <a style={styles.a} href="mailto:cmere@vertigo.com.br"> cmere@vertigo.com.br </a> <CgMail /> | claudiamere <FaDiscord />  </li>
              <li style={styles.liItem}><b>Priscila Madeira:</b> <a style={styles.a} href="mailto:pmadeira@vertigo.com.br"> pmadeira@vertigo.com.br </a> <CgMail /> | priscilamadeira <FaDiscord />  </li>
              <li style={styles.liItem}><b>Gustavo Paiva:</b> <a style={styles.a} href="mailto:gpaiva@vertigo.com.br"> gpaiva@vertigo.com.br </a> <CgMail /> | gustavopaiva063 <FaDiscord />  </li>
              <li style={styles.liItem}><b>Heber de Figueiredo:</b> <a style={styles.a} href="mailto:hagapito@vertigo.com.br"> hagapito@vertigo.com.br </a> <CgMail /> | heber_figueiredo <FaDiscord />  </li>
          </ul>
        </div>
      }
    </div>
    
  );
};

export default BoasVindas;